import { useState, useEffect, useContext } from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { CardSwapSearchResults } from "./CardSwapSearchResults/CardSwapSearchResults";
import { CardSwapStatusesSelect } from "./CardSwapStatusesSelect";
import { SelectMultipleVillages } from "../../components/SelectMultipleVillages/SelectMultipleVillages";
import VspPortalContext from "../../store/VspPortalContext";
import { useCookies } from "react-cookie";
import { UserGroup } from "../../enums/UserGroup";
import { CardSwapStatusCode } from "./enums/CardSwapStatusCode";
import RefreshIcon from '@mui/icons-material/Refresh';
import { CheckHealth } from "../Maintenance/components/CheckHealth";


export const CardSwap: React.FC = ( ) => {

    
    const [ defaultCardSwapStatuses, setDefaultCardSwapStatuses  ] = useState< string[]> ([ ]);
    const [ defaultVillages, setDefaultVillages  ] = useState< string[ ]> ([ ]);
    const [ refresh, setRefresh ] = useState< number >( 0 );
    const [ selectedCardSwapStatuses, setSelectedCardSwapStatuses ] = useState< string[ ] >( [ ] );
    const [ selectedVillages, setSelectedVillages ] = useState< string[ ] >( [ ] );

    
    const { state } = useContext( VspPortalContext );


    const [ cookies, setCookie, removeCookie ] = useCookies( );


    useEffect( () => {

        if( cookies[ 'card-swap-statuses' ] ) {

            setDefaultCardSwapStatuses( cookies[ 'card-swap-statuses' ] );
            setSelectedCardSwapStatuses( cookies[ 'card-swap-statuses' ] );

        } else {

            if( state.userGroups.includes( UserGroup.WaioSecurity ) ){

                setDefaultCardSwapStatuses( [ CardSwapStatusCode.CreatingNewCard ] );

            } 

            if( state.userGroups.includes( UserGroup.WaioReception ) ){

                setDefaultCardSwapStatuses( [ CardSwapStatusCode.NewCardCreated ] );

            }

        }

        if( cookies[ 'card-swap-villages' ] ) {

            setDefaultVillages( cookies[ 'card-swap-villages' ] );
            setSelectedVillages( cookies[ 'card-swap-villages' ] ); 

        }

    }, [ ] );


    const handleRefreshClick = () => setRefresh( r => r + 1 );


    const handleSelectVillages = ( villageCodes : string[ ] ) => { 
        
        setCookie( 'card-swap-villages', JSON.stringify( villageCodes ) );
        setSelectedVillages( villageCodes ); 
    
    };

    
    const handleSelectCardSwapStatuses = ( cardSwapStatuses : string[ ] ) => { 
        
        setCookie( 'card-swap-statuses', JSON.stringify( cardSwapStatuses ) );
        setSelectedCardSwapStatuses( cardSwapStatuses ); 

    };


    return(

        <>
            
            <CheckHealth />
            
            <Stack display="flex" alignItems="center">
                
                <Stack direction="row" display="flex" justifyContent="center" gap={ 1 } sx={{ boxAlign: 'center', marginTop: '20px', boxShadow: 5, padding: '15px', borderRadius: '3px' }}>
    
                    <CardSwapStatusesSelect defaultCardSwapStatuses={ defaultCardSwapStatuses } selectCardSwapStatuses={ handleSelectCardSwapStatuses }/>
                        
                    <SelectMultipleVillages defaultVillages={ defaultVillages } selectVillages={ handleSelectVillages }/>

                    <Tooltip title="Refresh">
                        <IconButton onClick={ handleRefreshClick } sx={{ marginTop: '5px', height: '50px', width: '50px' }}>
                            <RefreshIcon />
                        </IconButton>
                    </Tooltip>

                </Stack>

            </Stack>

            {

                ( selectedCardSwapStatuses.length > 0 && selectedVillages.length > 0 ) && <CardSwapSearchResults cardSwapStatuses={ selectedCardSwapStatuses } refresh={ refresh} villageCodes={ selectedVillages }/>

            }
            
        </>

    );


};